(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tab-content"] && !Shopify.designMode) return;
  try {
    

const loadMoreButton = document.querySelector(".load-more");
const pageContent = document.querySelector(".page-content");
loadMoreButton.addEventListener("click", function() { pageContent.classList.toggle("open"); });


  } catch(e) { console.error(e); }
})();
})();
